import { Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';

import * as _ from 'lodash';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-zc-indexing-process-details-view',
    templateUrl: './zc-indexing-process-details-view.component.html',
    styleUrls: ['./zc-indexing-process-details-view.component.scss']
})
export class ZCIndexingProcessDetailsViewComponent implements OnInit, OnDestroy {

    @Input()
    public task: ITaskModel;

    public isOpenChart = false;
    private destroy$ = new Subject<boolean>();

    constructor(
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: ITaskModel
    ) { }

    ngOnInit() {
        this.task = this.data || this.task;
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
